import React from 'react';
import BasicML from './BasicML';

export default (props) => <BasicML {...props} />;
